import { createSelector } from 'reselect';
import { initialState } from '../reducers/home';
import { peek, selector } from '../selectorHelpers';

export const selectHome = (state) => state.get('home', initialState);

export const homeSelectLoading = selector(selectHome, peek('isLoading'));
export const homeSelectLocaleLoaded = selector(
  selectHome,
  peek('localeLoaded'),
);
export const homeSelectSections = selector(selectHome, peek('sections'));
export const homeSelectSectionsContent = selector(
  selectHome,
  peek('sectionsContent'),
);
export const homeSelectSectionsContentLoading = selector(
  selectHome,
  peek('isSectionsContentLoading'),
);
export const homeSelectArticleLoading = selector(
  selectHome,
  peek('isArticleLoading'),
);

// Looks up a specific article inside sectionsContent[sectionCode]. Memoized
// via reselect so consecutive renders with the same state/sectionCode/
// articleCode return the same reference. Callers: HomeArticle (cache-first
// lookup before dispatching getHomeArticle).
// Pattern matches servicesSelectors.js:20 for selectors taking runtime args.
export const homeSelectArticleByCode = createSelector(
  [
    homeSelectSectionsContent,
    (_state, sectionCode) => sectionCode,
    (_state, _sectionCode, articleCode) => articleCode,
  ],
  (sectionsContent, sectionCode, articleCode) => {
    if (!sectionCode || !articleCode) return null;
    const articles = sectionsContent.get(sectionCode);
    if (!articles) return null;
    return articles.find((a) => a.get('code') === articleCode) || null;
  },
);
